/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./vrecord-usage.vue?vue&type=template&id=0d704cbb&scoped=true&"
import script from "./vrecord-usage.vue?vue&type=script&lang=js&"
export * from "./vrecord-usage.vue?vue&type=script&lang=js&"
import style0 from "./vrecord-usage.vue?vue&type=style&index=0&id=0d704cbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d704cbb",
  null
  
)

export default component.exports